var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"guide-container"},[_c('iframe',{staticClass:"guide-iframe",attrs:{"src":_vm.guideSrc,"frameborder":"0","allowfullscreen":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }